import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Button, Typography, TextField, Autocomplete, Paper, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { locationsOptions } from '../utilities/constants';

function HomePage() {
  const navigate = useNavigate();

  const [totalIndustries, setTotalIndustries] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({
    name: '',
    job_title: '',
    almaMater: '',
    education: [],
    location: [],
    industry: [],
    compellingEvents: [],
    gender: [],
    netWorthRange: [0, 20000000],
    ageRange: [0, 100],
  });


  const compellingEventsOptions = [
    "Inheritance",
    "Promotion",
    "Job Change",
    "Marriage",
    "Divorce",
    "Recently Moved",
    "Childbirth",
    "Reached Retirement Age",
    "Sale of Business",
    "Sale of stock",
    "Recent Fundraising Round",
    "Recent Donation"
  ];


  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await axios.get('https://api.pathvizor.com/industries'); // Replace with your API endpoint
        const responseArray = []
        response.data.forEach((industry) => {
            responseArray.push(
                industry.name
            )})

        setTotalIndustries(responseArray)
      } catch (err) {
        console.log('Failed to fetch industries. Please try again later.');
      } 
    };
    fetchIndustries();
  }, []);

    // Handle filter changes
    const handleFilterChange = (key, value) => {
        setSelectedFilters((prev) => ({
          ...prev,
          [key]: value,
        }));
      };

  const handleSearch = () => {
    navigate('/dashboard', { state: {
        filters: {
            education: [],
            location: selectedFilters.location,
            industry: selectedFilters.industry,
            compellingEvents: selectedFilters.compellingEvents,
            gender: [],
            netWorthRange: [],
            ageRange: [0, 100],
        },
        searchFields: {
            name: "",
            job_title: "",
            alma_mater: "",
        }  
        
    } });
  };

  // ============ UI RENDER ============
  return (
    <Box
    sx={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f5f5',
      padding: 2,
    }}
  >
    <Paper elevation={3} sx={{ padding: 4, maxWidth: 600, width: '100%' }}>
      <Typography variant="h5" gutterBottom>
        Search Filters
      </Typography>
      <Stack spacing={3}>
        {/* Money in Motion Events */}
        <Autocomplete
          multiple
          options={compellingEventsOptions}
          value={selectedFilters.compellingEvents}
          onChange={(_, newValue) => handleFilterChange('compellingEvents', newValue)}
          renderInput={(params) => <TextField {...params} label="Money in Motion Events" variant="outlined" />}
        />

        {/* Locations */}
        <Autocomplete
        multiple
        options={locationsOptions}
        getOptionLabel={(option) => option.name} // Display the full state name
        value={selectedFilters.location.map((abbreviation) =>
            locationsOptions.find((state) => state.abbreviation === abbreviation) || { name: '', abbreviation: '' }
        )} // Map abbreviations to full state objects
        onChange={(_, newValue) => {
            const abbreviations = newValue.map((state) => state.abbreviation); // Store only the abbreviations
            handleFilterChange('location', abbreviations);
        }}
        renderInput={(params) => <TextField {...params} label="Locations (US States)" variant="outlined" />}
        />

        {/* Industries */}
        <Autocomplete
            multiple
            options={totalIndustries}
            value={selectedFilters.industry}
            onChange={(_, newValue) => handleFilterChange('industry', newValue)}
            renderInput={(params) => <TextField {...params} label="Industries" variant="outlined" />}
          />

          {/* Search Button */}
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSearch}
            sx={{ alignSelf: 'center', width: '50%' }}
          >
            Search
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}

export default HomePage;
